/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
import {Quiz} from '~/components/Quiz';
export const meta = {
  title: 'OCP | Антипаттерны и запахи',
  description: 'Антипаттерны и запахи кода, которые мешают следовать принципу открытости-закрытости'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      section: "section",
      h1: "h1",
      p: "p",
      h2: "h2",
      a: "a",
      code: "code",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_components.section, {
      children: [_jsx(_components.h1, {
        children: "Антипаттерны и запахи"
      }), _jsx(_components.p, {
        children: "Все паттерны, которые так или иначе теснее связывают сущности между собой, можно назвать антипаттернами."
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Связывание через конкретные классы"
        }), _jsxs(_components.p, {
          children: ["Проблемы связывания через конкретные классы мы рассмотрели в ", _jsx(_components.a, {
            href: "/ocp/in-ideal-world",
            children: "примере"
          }), " из раздела «В идеальном мире». Класс ", _jsx(_components.code, {
            children: "AreaCalculator"
          }), " изначально зависел от конкретного класса ", _jsx(_components.code, {
            children: "Rectangle"
          }), ", из-за чего при изменении требований, приходилось обновлять код этого класса."]
        }), _jsxs(_components.p, {
          children: ["Когда мы ввели прослойку в виде интерфейса ", _jsx(_components.code, {
            children: "Shape"
          }), ", класс ", _jsx(_components.code, {
            children: "AreaCalculator"
          }), " начинал зависеть от интерфейса, а не от конкретных классов, изменение в требованиях перестало затрагивать код класса ", _jsx(_components.code, {
            children: "AreaCalculator"
          }), "."]
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Синглтон"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%9E%D0%B4%D0%B8%D0%BD%D0%BE%D1%87%D0%BA%D0%B0_(%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD_%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F)",
            children: "Синглтон"
          }), " — это паттерн, при котором в приложении существует только один экземпляр какого-то класса. Существующий синглтон гарантирует, что все новые созданные объекты будут ссылаться на него."]
        }), _jsxs(_components.p, {
          children: ["Если синглтон содержит в себе общее состояние или глобальные переменные, либо сам является глобальной сущностью, то зацепление объектов с ним ", _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%97%D0%B0%D1%86%D0%B5%D0%BF%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5_(%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5)",
            children: "чрезмерно высокое"
          }), "."]
        }), _jsx(_components.p, {
          children: "Это может приводить к ситуациям, когда при изменении требований приходится менять и сам синглтон, и все объекты, которые с ним связаны."
        }), _jsx(_components.p, {
          children: "Синглтон можно использовать и без высокого зацепления модулей (применяя, например, абстрактные интерфейсы), но это значительно усложняет структуру проекта."
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Легковес"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://refactoring.guru/ru/design-patterns/flyweight",
            children: "Легковес"
          }), " — шаблон, который уменьшает расход памяти, держа общее состояние объектов внутри себя, вместо хранения одинаковых данных в каждом объекте."]
        }), _jsx(_components.p, {
          children: "Его проблема с точки зрения OCP в том же высоком связывании модулей. Если сущность выступает в роли общего контекста для нескольких объектов, при изменении требований придётся менять код каждого модуля."
        }), _jsx(_components.p, {
          children: "Как и в случае с синглтоном, с легковесом можно работать без высокого зацепления, но это также будет увеличивать сложность."
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Материалы к разделу"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://ru.wikipedia.org/wiki/%D0%9E%D0%B4%D0%B8%D0%BD%D0%BE%D1%87%D0%BA%D0%B0_(%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD_%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F)",
              children: "Синглтон"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://refactoring.guru/ru/design-patterns/flyweight",
              children: "Легковес"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://en.wikipedia.org/wiki/Coupling_(computer_programming)",
              children: "Зацепление модулей"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://williamdurand.fr/2013/07/30/from-stupid-to-solid-code/",
              children: "STUPID → SOLID"
            })
          }), "\n"]
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Вопросы"
        }), _jsx(Quiz, {
          name: "ocp-anti-1"
        }), _jsx(Quiz, {
          name: "ocp-anti-2"
        }), _jsx(Quiz, {
          name: "ocp-anti-3"
        })]
      })]
    });
  }
}
export default MDXContent;
